import Swiper from "swiper";

let slider = new Swiper('.m-projects__grid', {
    slidesPerView: 'auto',
});